module.exports = __webpack_public_path__ + "static/media/legalWarning.77df74fe.pdf";